import { ChangeDetectionStrategy, Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { GeoGebraWidgetConfigInterface } from '../../interfaces/geogebra-widget.service.interface';
import { GeogebraWidgetService } from '../../services';

@Component({
    selector: 'campus-geogebra-calculator',
    templateUrl: './calculator.component.html',
    styleUrls: ['./calculator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: '[ relative index-overlay ] [ h-full w-full m-0 ] [ top-0 left-0 ] [ surface ]' },
    providers: [GeogebraWidgetService],
    standalone: false
})
export class CalculatorComponent implements OnInit {
  private dialogRef = inject(MatDialogRef);

  private geogebraWidgetService = inject(GeogebraWidgetService);
  private widgetConfig: GeoGebraWidgetConfigInterface = {
    elementId: 'geogebra_calculator',
    appName: 'scientific',
    scaleContainerClass: 'widget-container',
    width: 1200,
    height: 600,
    errorDialogsActive: true,
    useBrowserForJS: false,
    showAlgebraInput: true,
    showToolBar: true,
  };

  ngOnInit(): void {
    this.geogebraWidgetService.init(this.widgetConfig);
  }

  public onCloseClicked() {
    this.dialogRef.close();
  }
}
